import { Spin, SpinProps } from "antd";
import loading from "shared/assets/images/loading.png";
import "./Loader.scss";
import { useTranslation } from "react-i18next";

interface LoaderProps extends SpinProps {
  hidden?: boolean;
  fontSize?: number;
  global?: boolean;
  tip?: string;
}

const Locale: React.FC<LoaderProps> = (props) => {
  const { hidden, tip, fontSize = 24 } = props;
  const { t } = useTranslation("radar");
  if (hidden) return null;
  return (
    <Spin
      indicator={
        <img
          alt="loader"
          src={loading}
          style={{ fontSize, width: 150, height: 150 }}
          className="loader-rotation"
        />
      }
      tip={tip ? tip : t("components.Loader.loading")}
      {...props}
    />
  );
};

export default Locale;
